import React from 'react';
import PropTypes from 'prop-types';
import PackageChooser from '../../../PackageChooser';
import { useCustomer } from '../../../../contexts/CustomerContext';
import useOfferCoupon from '../../../../hooks/useOfferCoupon';
import useApplyOfferToCart from '../../../../hooks/useApplyOfferToCart';

// The $0 "yearbook" Option, identified the way the rest of the senior flow does: the
// Option whose name includes "yearbook".
const isYearbookOption = (option) => option?.name?.toLowerCase().includes('yearbook');

/**
 * The senior flavour of PackageChooser. Two things are true only of seniors:
 *
 *  - The $0 yearbook line is NOT a package to choose here — it's already in the cart from
 *    the gallery step — so its Option is dropped from the grid.
 *  - A senior may want nothing but their yearbook photo, so there's a way straight to
 *    review/checkout with that $0 line alone.
 *
 * Everything else (pricing, cards, previews) is the shared screen — each card composites
 * the student's own poses via AbsolutePosImgs, so no hero-photo prop is needed here.
 */
export default function SeniorPackageChooser({
  packageId, onSelect, onSkip,
}) {
  const { customer } = useCustomer();

  // The promotional offer to feature for this student right now, resolved by
  // days-since-photographed and scoped to this pricelist so checkout will honor it.
  const { data: offer } = useOfferCoupon(
    customer?.currentStudent?.studentId,
    customer?.currentSchool?.id,
    packageId,
  );
  // Auto-apply it so the discount rides into checkout without the customer typing a code.
  useApplyOfferToCart(offer);

  return (
    <PackageChooser
      packageId={packageId}
      schoolId={customer.currentSchool.id}
      subline="Pick the package you want to build."
      excludeOption={isYearbookOption}
      onSelect={onSelect}
      skip={{ label: 'No thanks — just my yearbook photo', onClick: onSkip }}
      offer={offer}
    />
  );
}

SeniorPackageChooser.propTypes = {
  packageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSelect: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};
